import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState, useCallback, useRef} from "react";
import Button from "react-bootstrap/Button";
import apiClient, {baseUrl} from '../../services/axios/index'
import LoaderService from "../../RetroAssets.System/LoaderService";
import {alert, confirm} from "devextreme/ui/dialog";
import {
    DateBox,
    FileUploader,
    NumberBox,
    SelectBox,
    Template,
    TextArea,
    TextBox,
    ValidationGroup
} from "devextreme-react";
import RetroFormItem from "../../RetroAssets.System/FormGroup";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import InputGroup from "react-bootstrap/esm/InputGroup";
import {Button as DataGridButton, Column, DataGrid} from "devextreme-react/data-grid";
import cl from "../../RetroAssets.System/Utilities";
import {ContextMenuTemplate, MoreOptionsButton} from "../../RetroAssets.System/MoreOptionsButton";
import Validator, {RequiredRule} from "devextreme-react/validator";

function ManageBankLoanDetails(props) {
    const {show, externalId, readOnly} = props
    const validationGroup = useRef(null)
    const [showModal, setShowModal] = useState(false);
    const [bankLoanDetails, setBankLoanDetails] = useState({});
    const [allCurrencies, setAllCurrencies] = useState([]);
    const [allProperties, setAllProperties] = useState([]);
    const [allLoanAccounts, setAllLoanAccounts] = useState([]);
    const [activatedTabs, setActivatedTabs] = useState([]);

    const [gridHeight, setGridHeight] = useState(0)

    const faSearchBoxRef = useRef(null)
    const faGridInstance = useRef(null);
    const [faData, setFaData] = useState([])
    const [faColumns, setFaColumns] = useState([])
    const [faGridCustomization, setFaGridCustomization] = useState({})
    const [faEditedData, setFaEditedData] = useState([]);
    const [deletedFileAttachments, setDeletedFileAttachments] = useState([]);

    let attachmentSpanString = "ItemDocumentList"
    let fileAttachmentCounter = 0;
    let attachedFileCount = 0;
    let attachmentValueChangedEventExecuted = false;
    const attachmentButtonInstance = useRef(null);

    const [attachedFileList, setAttachedFileList] = useState([])
    const [newItemIndex, setNewItemIndex] = useState(0)

    const modalClose = () => {
        props.handleClose()
        setShowModal(false);
    }

    useEffect(() => {
        if (!show) return
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalId: externalId
        })
        apiClient
            .get('/BankLoan/GetBankLoanDetails?' + params)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    let blDetail = data[0]["BankLoanDetails"]["Data"]
                    if (externalId) {
                        blDetail["Currency"] = cl.getEcoIdFromExternalId(blDetail["Currency"]);
                        blDetail["Property"] = cl.getEcoIdFromExternalId(blDetail["Property"]);
                        blDetail["Account"] = cl.getEcoIdFromExternalId(blDetail["Account"]);
                    }
                    setBankLoanDetails(blDetail)
                    setAllProperties(data[1]["AllProperties"])
                    setAllCurrencies(data[2]["AllCurrencies"])
                    setAllLoanAccounts(data[3]["AllLoanAccounts"])
                    setShowModal(true)
                    let el = document.getElementById("ManageBankLoan_DetailsTab").clientHeight
                    setGridHeight(el - 52)
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })


    }, [show, externalId, readOnly])

    const valueChangeHandler = e => {
        if (!e.event) return
        let prop = e.component.option("property")
        setBankLoanDetails({
            ...bankLoanDetails,
            [prop]: e.value
        })
    }

    const tabSelectionChanged = e => {
        const index = activatedTabs.findIndex(x => x === e);
        if (index > -1) {
            return;
        }
        setActivatedTabs(oldArray => [...oldArray, e]);
        let url = ""
        if (e === "Attachments") {
            let params = new URLSearchParams({
                externalId: externalId,
                objectType: "Transaction"
            })
            url = "/BankLoan/GetFileAttachments?" + params
        }
        if (!url)
            return;
        LoaderService.setData(true)
        apiClient
            .get(url)
            .then(response => {
                try {
                    let data = JSON.parse(response.data)
                    setFaData(data[0]["Data"] ?? [])
                    let settings = data[1]["Settings"]
                    setFaColumns(settings[0][attachmentSpanString][0]["Columns"])
                    let gc = settings[0][attachmentSpanString][3]["GridCustomization"][0]
                    setFaGridCustomization(cl.enableDisableDataGridEditing(gc, null))
                    setTimeout(() => {
                        faGridInstance.current.instance().repaint()
                    }, 500)
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    //#region Attachment Tab
    const clearFilterFileAttachment = () => {
        faGridInstance.current?.instance().clearFilter()
        faGridInstance.current?.instance().searchByText('')
        faSearchBoxRef.current?.instance().option('value', null)
    }

    const searchDocumentByText = e => {
        if (!e.event) return
        faGridInstance.current?.instance().searchByText(e.value ? e.value : null)
    }

    const fileUploaded = useCallback((e) => {
        if (e.value.length === 0) return;
        let nwIndex = newItemIndex;
        e.value.forEach((val, index) => {
            if (val.hasOwnProperty("uniqueId")) return
            let ind = `NNNN${nwIndex}`;
            faData.push({
                Name: val.name,
                DocumentType: '',
                externalId: ind,
                DocumentLanguage: '',
                ExpiryDate: null,
                Status: '',
                isNew: true,
            });
            e.value[index]['uniqueId'] = ind;
            attachedFileList.push({uniqueId: ind, value: val})
            nwIndex++
        });
        setFaData(faData);
        setAttachedFileList(attachedFileList)
        setNewItemIndex(nwIndex)
        faGridInstance.current.instance().refresh();
    }, [newItemIndex, faData, attachedFileList])

    function resetAttachmentControl() {
        attachmentValueChangedEventExecuted = true;
        attachmentButtonInstance.current.instance().reset();
        attachmentValueChangedEventExecuted = false;
        attachedFileCount = 0;
        fileAttachmentCounter = 0;
    }

    const executeAttachmentCommands = useCallback(() => {
        attachmentButtonInstance.current.instance()._isCustomClickEvent = true;
        attachmentButtonInstance.current.instance()['_$fileInput'][0].click();
    }, []);

    const selectionChangedFileAttachments = e => {
        cl.singleSelectionCheckbox(e);
    };

    const refRowValidating = e => {
        setFaEditedData(cl.rowValidatingEvent(e, faEditedData));
    };

    const cellPreparedFileAttachments = e => {
        cl.setHeaderTooltip(e);
    };

    const addNewAttachments = () => {
        executeAttachmentCommands()
    }

    const buttonDownloadFile = (e) => {
        faGridInstance.current?.instance().selectRows([e.row.key], false)
        return downloadSelected()
    }

    const downloadSelected = () => {
        let ids = faGridInstance.current.instance().getSelectedRowKeys();
        if (ids.length === 0) return alert("Please select one or more files to download.", "Warning!")
        LoaderService.setData(true)
        let params = new URLSearchParams({
            externalIds: ids.toString(),
            objectType: 'Property',
            rootObjectExternalId: externalId
        })
        apiClient
            .get('/Shared/GenerateDocumentsReport?' + params)
            .then(response => {
                try {
                    let resp = JSON.parse(response.data)
                    LoaderService.setData(false)
                    if (resp[0].response) {
                        let path = baseUrl() + resp[0]['message'];
                        let win = window.open(path, '_blank');
                        win.focus();
                    } else {
                        return alert(resp[0].message + '<br /><br /><i>[TIP: Most errors in file downloads are caused by popup blockers.' +
                            '<br />Kindly configure your browser to allow popups if errors persist.</i>', 'Warning!');
                    }
                    LoaderService.setData(false)
                } catch (e) {
                    LoaderService.setData(false)
                    return alert(response.data, 'Error!')
                }

            })
            .catch(err => {
                LoaderService.setData(false)
                console.log(err)
                return alert(err, 'Error!')
            })
    }

    const deleteFileAttachment = useCallback((e) => {
        confirm("Are you sure you wish to delete?", "Warning!").then(resp => {
            if (resp) {
                let index = faEditedData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    faEditedData.splice(index, 1)
                    setFaEditedData(faEditedData)
                }

                index = attachedFileList.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    attachedFileList.splice(index, 1)
                    setAttachedFileList(attachedFileList)
                }

                index = faData.findIndex(x => x["externalId"] === e.row.key)
                if (index > -1) {
                    faData.splice(index, 1)
                    faGridInstance.current.instance().option("dataSource", faData)
                    setFaData(faData)
                }

                faGridInstance.current.instance().repaint()
                if (e.row.key.includes("NNNN")) return

                let items = attachmentButtonInstance.current.instance().option('value');
                index = items.findIndex(x => x["uniqueId"] === e.row.key)
                if (index > -1) {
                    items.splice(index, 1)
                    attachmentButtonInstance.current.instance().option('value', items);
                }
                deletedFileAttachments.push(e.row.key)
                setDeletedFileAttachments(deletedFileAttachments)
            }
        })
    }, [faEditedData, deletedFileAttachments, faData, attachedFileList])

    //#endregion

    const saveData = () => {
        if (!validationGroup.current.instance().validate().isValid) {
            return
        }
        LoaderService.setData(true);
        let formData = new FormData();
        formData.append('BankLoanData', JSON.stringify(bankLoanDetails));
        formData.append('BankLoanSpanString', '_BankLoanDetails');
        formData.append('FileAttachmentData', JSON.stringify(faData));
        formData.append(
            'FileAttachmentEditedData',
            JSON.stringify([{spanString: attachmentSpanString, editedData: faEditedData}]),
        );
        formData.append('DeletedFileAttachments', JSON.stringify(deletedFileAttachments));
        attachedFileList.forEach(val => {
            formData.append(val['uniqueId'], val['value'], val['uniqueId'])
        })
        apiClient
            .post('/BankLoan/AddUpdateBankLoan', formData)
            .then(response => {
                if (response) {
                    try {
                        LoaderService.setData(false);
                        let resp = JSON.parse(response.data);
                        resetAttachmentControl();
                        modalClose();
                        if (resp[0].response) {
                            props.isUpdated();
                        } else {
                            return alert(resp[0].message, 'Warning!');
                        }
                    } catch (e) {
                        resetAttachmentControl();
                        modalClose();
                        LoaderService.setData(false);
                        return alert(response.data, 'Error!');
                    }
                }
            })
            .catch(err => {
                LoaderService.setData(false);
                console.log(err);
            });
    }


    return (<Modal show={showModal} onHide={modalClose} centered dialogClassName="modal-80w prop-img-slider"
                   backdrop="static" keyboard={false}>
            <Modal.Header closeButton className="border-0 pb-0 modal-header">
                <Modal.Title className="fs-5 fw-bold">
                    <span>MANAGE BANK LOAN DETAILS</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-2">
                <FileUploader
                    style={{display: 'none'}}
                    ref={attachmentButtonInstance}
                    multiple={true}
                    accept=".pdf, .xlsx, .xls, .doc, .docx, .txt, .jpg, .png, .bmp"
                    labelText=""
                    allowCanceling={false}
                    showFileList={false}
                    selectButtonText="Add Documents"
                    onValueChanged={fileUploaded}
                    uploadMode="useForm"
                ></FileUploader>
                <Tabs defaultActiveKey="Details" className="fs-6 nav-tab tab-sm inner-tab"
                      onSelect={tabSelectionChanged}>
                    <Tab eventKey="Details" title="Details">
                       <ValidationGroup ref={validationGroup}>
                           <div className="py-2 tabs-border" id="ManageBankLoan_DetailsTab">
                               <div className="row tabsContent">
                                   {/*Account*/}
                                   <div className="col-sm-12 col-md-12">
                                       <RetroFormItem
                                           label={"Loan Account"}
                                           mandatory={true}
                                           valueField={
                                               <SelectBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Loan Account"
                                                   dataSource={allLoanAccounts}
                                                   displayExpr={"Name"}
                                                   valueExpr={"externalId"}
                                                   property="Account"
                                                   value={bankLoanDetails["Account"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               >
                                                   <Validator>
                                                       <RequiredRule message="Loan Account cannot be empty."/>
                                                   </Validator>
                                               </SelectBox>}
                                       ></RetroFormItem>
                                   </div>
                                   {/*Property*/}
                                   <div className="col-sm-12 col-md-12">
                                       <RetroFormItem
                                           label={"Property"}
                                           mandatory={false}
                                           valueField={
                                               <SelectBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Property"
                                                   dataSource={allProperties}
                                                   displayExpr={"DisplayPropertyName"}
                                                   valueExpr={"externalId"}
                                                   property="Property"
                                                   value={bankLoanDetails["Property"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               />}
                                       ></RetroFormItem>
                                   </div>
                                   {/*BankName*/}
                                   {/*<div className="col-sm-12 col-md-6">*/}
                                   {/*    <RetroFormItem*/}
                                   {/*        label={"Bank Name"}*/}
                                   {/*        mandatory={true}*/}
                                   {/*        valueField={*/}
                                   {/*            <TextBox*/}
                                   {/*                inputAttr={{class: "form-control"}}*/}
                                   {/*                elementAttr={{class: "input-group"}}*/}
                                   {/*                placeholder="Bank Name"*/}
                                   {/*                property="BankName"*/}
                                   {/*                value={bankLoanDetails["BankName"]}*/}
                                   {/*                onValueChanged={valueChangeHandler}*/}
                                   {/*                readOnly={readOnly}*/}
                                   {/*            />}*/}
                                   {/*    ></RetroFormItem>*/}
                                   {/*</div>*/}
                                   {/*LoanReferenceNumber*/}
                                   <div className="col-sm-12 col-md-6">
                                       <RetroFormItem
                                           label={"Loan Ref. No."}
                                           mandatory={true}
                                           valueField={
                                               <TextBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Loan Ref. No."
                                                   property="LoanReferenceNumber"
                                                   value={bankLoanDetails["LoanReferenceNumber"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               />}
                                       ></RetroFormItem>
                                   </div>
                                   {/*StartDate*/}
                                   <div className="col-sm-12 col-md-6">
                                       <RetroFormItem
                                           label={"Start Date"}
                                           mandatory={true}
                                           valueField={
                                               <DateBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Start Date"
                                                   displayFormat={"dd/MM/yyyy"}
                                                   property="StartDate"
                                                   value={bankLoanDetails["StartDate"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               >
                                                   <Validator>
                                                       <RequiredRule message="Start Date cannot be empty."/>
                                                   </Validator>
                                               </DateBox>}
                                       ></RetroFormItem>
                                   </div>
                                   {/*Tenure*/}
                                   <div className="col-sm-12 col-md-6">
                                       <RetroFormItem
                                           label={"Tenure (Year)"}
                                           mandatory={false}
                                           valueField={
                                               <NumberBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Tenure (Year)"
                                                   property="Tenure"
                                                   value={bankLoanDetails["Tenure"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               />}
                                       ></RetroFormItem>
                                   </div>
                                   {/*Currency*/}
                                   <div className="col-sm-12 col-md-6">
                                       <RetroFormItem
                                           label={"Currency"}
                                           mandatory={true}
                                           valueField={
                                               <SelectBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   dataSource={allCurrencies}
                                                   placeholder="Currency"
                                                   property="Currency"
                                                   displayExpr={"Name"}
                                                   valueExpr={"externalId"}
                                                   value={bankLoanDetails["Currency"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               >
                                                   <Validator>
                                                       <RequiredRule message="Currency cannot be empty."/>
                                                   </Validator>
                                               </SelectBox>}
                                       ></RetroFormItem>
                                   </div>
                                   {/*Amount*/}
                                   <div className="col-sm-12 col-md-6">
                                       <RetroFormItem
                                           label={"Loan Amount"}
                                           mandatory={true}
                                           valueField={
                                               <NumberBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Loan Amount"
                                                   format={"#,#00.00"}
                                                   property="Amount"
                                                   value={bankLoanDetails["Amount"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               >
                                                   <Validator>
                                                       <RequiredRule message="Loan Amount cannot be empty."/>
                                                   </Validator>

                                               </NumberBox>}
                                       ></RetroFormItem>
                                   </div>
                                   {/*EndDate*/}
                                   <div className="col-sm-12 col-md-6">
                                       <RetroFormItem
                                           label={"End Date"}
                                           mandatory={true}
                                           valueField={
                                               <DateBox
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="End Date"
                                                   displayFormat={"dd/MM/yyyy"}
                                                   property="EndDate"
                                                   value={bankLoanDetails["EndDate"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               >
                                               </DateBox>}
                                       ></RetroFormItem>
                                   </div>
                                   {/*Remarks*/}
                                   <div className="col-sm-12 col-md-12">
                                       <RetroFormItem
                                           label={"Remarks"}
                                           mandatory={false}
                                           valueField={
                                               <TextArea
                                                   inputAttr={{class: "form-control"}}
                                                   elementAttr={{class: "input-group"}}
                                                   placeholder="Remarks"
                                                   property="Remarks"
                                                   height={80}
                                                   value={bankLoanDetails["Remarks"]}
                                                   onValueChanged={valueChangeHandler}
                                                   readOnly={readOnly}
                                               />}
                                       ></RetroFormItem>
                                   </div>
                               </div>
                           </div>
                       </ValidationGroup>
                    </Tab>
                    <Tab eventKey="Attachments" title="Attachments">
                        <div className="py-2 tabs-border">
                            <div className="row tabsContent">
                                <div
                                    className="d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mb-2">
                                    <h4 className="fs-4 fw-medium mb-3 mb-sm-0"></h4>
                                    <div className="d-flex">
                                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                                onClick={clearFilterFileAttachment}>
                                            Clear Filter
                                        </Button>
                                        <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                                onClick={downloadSelected}>
                                            Download
                                        </Button>
                                        {readOnly ? <></> :
                                            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                                                    onClick={addNewAttachments}>
                                                Add Documents
                                            </Button>}
                                        <InputGroup className="me-3 search-input">
                                            <TextBox
                                                ref={faSearchBoxRef}
                                                placeholder="Search Documents..."
                                                mode="search"
                                                inputAttr={{class: "form-control"}}
                                                elementAttr={{class: "search-input input-group"}}
                                                width="100%"
                                                onValueChanged={searchDocumentByText}
                                            ></TextBox>
                                        </InputGroup>
                                    </div>
                                </div>
                                <DataGrid
                                    ref={faGridInstance}
                                    keyExpr="externalId"
                                    dataSource={faData}
                                    // columns={faColumns}
                                    height={gridHeight}
                                    onCellPrepared={cellPreparedFileAttachments}
                                    onRowValidating={refRowValidating}
                                    onSelectionChanged={selectionChangedFileAttachments}
                                    {...faGridCustomization}
                                >
                                    {faColumns.map(column => (cl.generateReactColumnsFromJson(column)))}
                                    <Column
                                        type="buttons"
                                        width="8%"
                                    >
                                        {readOnly ?
                                            <></> :
                                            <DataGridButton
                                                icon={"trash"}
                                                visible={true}
                                                onClick={deleteFileAttachment}
                                            ></DataGridButton>
                                        }
                                        <DataGridButton
                                            icon="chevrondown"
                                            visible={true}
                                            onClick={buttonDownloadFile}
                                        ></DataGridButton>
                                    </Column>
                                    <Template name="contextMenuTemplate" render={ContextMenuTemplate}/>
                                    <Template name="myTemplate" render={MoreOptionsButton}/>
                                </DataGrid>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
            <Modal.Footer className="pt-2">
                <>
                    <Button variant="outline-primary" className="flex-shrink-0 me-3"
                            onClick={saveData}>
                        Save
                    </Button>
                    <Button variant="outline-primary" className="flex-shrink-0 me-3"
                            onClick={modalClose}>
                        Cancel
                    </Button>
                </>
            </Modal.Footer>
        </Modal>
    )
}

export default ManageBankLoanDetails;